/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResultDto,
} from '../models/index';
import {
    ResultDtoFromJSON,
    ResultDtoToJSON,
} from '../models/index';

export interface ItemsControllerGetSalesItemWithPropertyRequest {
    property: ItemsControllerGetSalesItemWithPropertyPropertyEnum;
}

/**
 * 
 */
export class ItemsApi extends runtime.BaseAPI {

    /**
     */
    async itemsControllerGetSalesItemWithPropertyRaw(requestParameters: ItemsControllerGetSalesItemWithPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        if (requestParameters['property'] == null) {
            throw new runtime.RequiredError(
                'property',
                'Required parameter "property" was null or undefined when calling itemsControllerGetSalesItemWithProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/items/{property}`;
        urlPath = urlPath.replace(`{${"property"}}`, encodeURIComponent(String(requestParameters['property'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async itemsControllerGetSalesItemWithProperty(requestParameters: ItemsControllerGetSalesItemWithPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.itemsControllerGetSalesItemWithPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async itemsControllerGetSalesItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/items`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async itemsControllerGetSalesItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.itemsControllerGetSalesItemsRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ItemsControllerGetSalesItemWithPropertyPropertyEnum = {
    Properties10: 'Properties10',
    Properties11: 'Properties11'
} as const;
export type ItemsControllerGetSalesItemWithPropertyPropertyEnum = typeof ItemsControllerGetSalesItemWithPropertyPropertyEnum[keyof typeof ItemsControllerGetSalesItemWithPropertyPropertyEnum];
